/* eslint-disable react-refresh/only-export-components -- route module exports the router object + helpers, not just components */
import { lazy, Suspense, type ReactNode } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { KioskShell } from './kiosk-shell';
import { id } from '@/i18n/id';

// Route-level code splitting — each screen is its own bundle so the service
// worker can pre-cache per route and the initial JS stays under budget.
const WelcomeScreen = lazy(() => import('@/screens/welcome/welcome-screen'));
const OrderTypeScreen = lazy(() => import('@/screens/order-type/order-type-screen'));
const MenuScreen = lazy(() => import('@/screens/menu/menu-screen'));
const CustomizationScreen = lazy(() => import('@/screens/customization/customization-screen'));
const CartScreen = lazy(() => import('@/screens/cart/cart-screen'));
const ConfirmationScreen = lazy(() => import('@/screens/confirmation/confirmation-screen'));
const InstructionsScreen = lazy(() => import('@/screens/instructions/instructions-screen'));

function Fallback() {
  return (
    <div className="flex h-full items-center justify-center text-ink-muted">{id.common.loading}</div>
  );
}

function lazyScreen(node: ReactNode) {
  return <Suspense fallback={<Fallback />}>{node}</Suspense>;
}

function ErrorScreen() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-10 text-center">
      <h1 className="text-3xl font-bold">{id.common.errorTitle}</h1>
      <p className="text-lg text-ink-muted">{id.common.errorBody}</p>
    </div>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <KioskShell />,
    errorElement: <ErrorScreen />,
    children: [
      { index: true, element: lazyScreen(<WelcomeScreen />) },
      { path: 'order-type', element: lazyScreen(<OrderTypeScreen />) },
      { path: 'menu', element: lazyScreen(<MenuScreen />) },
      { path: 'customize/:itemId', element: lazyScreen(<CustomizationScreen />) },
      { path: 'cart', element: lazyScreen(<CartScreen />) },
      { path: 'confirm', element: lazyScreen(<ConfirmationScreen />) },
      { path: 'instructions/:orderId', element: lazyScreen(<InstructionsScreen />) },
    ],
  },
]);
